import React, { FC, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks/useStores';
import Skeleton from 'ati-ui-react/components/Skeleton';
import nanoid from 'nanoid';
import { addMetric } from 'utils/addMetrics';
import { ICheckPopupParams, IChecks } from 'interfaces/IChecksStore';

import CheckCard from '../CheckCard';
import CheckTransportPopup from '../CheckTransportPopup';

import { CheckCardListContainer } from './CheckCardListStyles';

const CheckCardList: FC = observer(() => {
  const {
    checksStore: { checkTransportUrlStatus, checks, checksStatus, setCheckPopupParams },
    advertsStore: {
      // @ts-ignore
      currentAdvert: { advert_items, _id },
    },
    notificationStore: { pushNotification },
  } = useStores();

  useEffect(() => {
    if (checkTransportUrlStatus.isFailure) {
      pushNotification(
        'Сервис недоступен. Перезагрузите, пожалуйста, страницу или зайдите позже.',
        'error',
      );
    }
  }, [checkTransportUrlStatus.state]);

  const getChecksFields = (obj: IChecks): ICheckPopupParams => {
    return {
      advert_id: _id,
      check_id: obj.id,
      amount: obj.amount,
      description: obj.description,
      limit_balance: obj.limit_balance,
      transport_position: 0,
    };
  };

  const onHandleClick = (checksObj: IChecks) => {
    addMetric('tm-click-check');
    const checksFields = getChecksFields(checksObj);
    const { transport_position, ...checkParamsItem } = checksFields;

    if (advert_items) {
      return setCheckPopupParams(checksFields);
    }

    return setCheckPopupParams(checkParamsItem);
  };

  return (
    <>
      <CheckTransportPopup />
      <CheckCardListContainer>
        {!checksStatus.isRequest ? (
          checks?.map((item) => {
            return (
              <div key={nanoid()}>
                <CheckCard
                  image={item.checker}
                  description={item.description}
                  limitBalance={item.limit_balance}
                  amount={item.amount}
                  promoAmount={item?.promo_amount}
                  onClick={() => onHandleClick(item)}
                />
              </div>
            );
          })
        ) : (
          <Skeleton height={312} />
        )}
      </CheckCardListContainer>
    </>
  );
});

export default CheckCardList;
